import * as Types from '../constants/Types';

export const dataTourAction = (filters) => ({ type: Types.TOUR_LIST_ACTION, filters });
export const dataTourSuccess = (tours) => ({ type: Types.TOUR_LIST_SUCCESS, tours });

export const getUpdateTourAction = (params) => ({ type: Types.TOUR_GET_UPDATE_ACTION, params });
export const getUpdateTourSuccess = (dataUpdate) => ({ type: Types.TOUR_GET_UPDATE_SUCCESS, dataUpdate });

export const deleteTourAction = (params) => ({ type: Types.TOUR_DELETE_ACTION, params });
export const updateTourAction = (params) => ({ type: Types.TOUR_UPDATE_ACTION, params });

export const createTourAction = (params) => ({ type: Types.TOUR_CREATE_ACTION, params });

export const deleteTourLineAction = (params) => ({ type: Types.TOUR_LINE_DELETE_ACTION, params });
export const deleteTourLineSuccess = (result) => ({ type: Types.TOUR_LINE_DELETE_SUCCESS, result });
export const updateTourLineAction = (params) => ({ type: Types.TOUR_LINE_UPDATE_ACTION, params });
export const updateTourLineSuccess = (result) => ({ type: Types.TOUR_LINE_UPDATE_SUCCESS, result });
export const createTourLineAction = (params) => ({ type: Types.TOUR_LINE_CREATE_ACTION, params });
export const createTourLineSuccess = (result) => ({ type: Types.TOUR_LINE_CREATE_SUCCESS, result });

export const createMultipleTourLineAction = (params) => ({ type: Types.MULTIPLE_TOUR_LINE_CREATE_ACTION, params });
export const createMultipleTourLineSuccess = (result) => ({ type: Types.MULTIPLE_TOUR_LINE_CREATE_SUCCESS, result });

export const exportExcel = (params) => ({ type: Types.TOUR_EXPORT_EXCEL_ACTION, params });
export const cloneTourAction = (id, lengthOfStay, isCopyTourTickets, refreshParams) => ({ type: Types.TOUR_CLONE_ITEM_ACTION, id, lengthOfStay, isCopyTourTickets, refreshParams });

// NEW TOUR PROCESS:

export const getListTours = (params) => ({ type: Types.TOUR_GET_LIST_ACTION, params });
export const setListTours = (data) => ({ type: Types.TOUR_GET_LIST_SUCCESS, ...(data || {}) });

export const getTourDetail = (id) => ({ type: Types.TOUR_DETAIL_ACTION, id });
export const setTourDetail = (tour) => ({ type: Types.TOUR_DETAIL_SUCCESS, tour });
export const updateTour = (tour) => ({ type: Types.TOUR_DETAIL_UPDATE_ACTION, tour });
export const createTour = (tour) => ({ type: Types.TOUR_DETAIL_CREATE_ACTION, tour });
export const deleteTour = (tour, refreshParams) => ({ type: Types.TOUR_DETAIL_DELETE_ACTION, tour, refreshParams });

export const getAllTourTypes = () => ({ type: Types.TOUR_TYPE_GET_ALL_ACTION });
export const setAllTourTypes = (tourTypes) => ({ type: Types.TOUR_TYPE_GET_ALL_SUCCESS, tourTypes });
export const getTourTypeDetail = (id) => ({ type: Types.TOUR_TYPE_DETAIL_ACTION, id });
export const setTourTypeDetail = (tourType) => ({ type: Types.TOUR_TYPE_DETAIL_SUCCESS, tourType });
export const updateTourType = (tourType) => ({ type: Types.TOUR_TYPE_DETAIL_UPDATE_ACTION, tourType });
export const createTourType = (tourType) => ({ type: Types.TOUR_TYPE_DETAIL_CREATE_ACTION, tourType });
export const deleteTourType = (tourType, refreshParams) => ({ type: Types.TOUR_TYPE_DETAIL_DELETE_ACTION, tourType, refreshParams });
export const deleteTourTypeSucess = (id) => ({ type: Types.TOUR_TYPE_DETAIL_DELETE_SUCCESS, id });

export const getAllSurchargeCategories = () => ({ type: Types.TOUR_SURCHARGE_CATEGORIES_GET_ALL_ACTION });
export const setAllSurchargeCategories = (surchargeCategories) => ({ type: Types.TOUR_SURCHARGE_CATEGORIES_GET_ALL_SUCCESS, surchargeCategories });
export const getSurchargeCategoriesDetail = (id) => ({ type: Types.TOUR_SURCHARGE_CATEGORIES_DETAIL_ACTION, id });
export const setSurchargeCategoriesDetail = (surchargeCategories) => ({ type: Types.TOUR_SURCHARGE_CATEGORIES_DETAIL_SUCCESS, surchargeCategories });
export const createSurchargeCategories = (surchargeCategories) => ({ type: Types.TOUR_SURCHARGE_CATEGORIES_DETAIL_CREATE_ACTION, surchargeCategories });

export const getListTourLines = (tourId, params, isTour, isEndpointAdmin = true) => ({ type: Types.TOUR_LINE_GET_LIST_ACTION, tourId, params, isTour, isEndpointAdmin });

export const setListTourLines = (data) => ({ type: Types.TOUR_LINE_GET_LIST_SUCCESS, ...(data || {}) });
export const getTourLineDetail = (id) => ({ type: Types.TOUR_LINE_DETAIL_ACTION, id });
export const setTourLineDetail = (tourLine) => ({ type: Types.TOUR_LINE_DETAIL_SUCCESS, tourLine });
export const updateTourLine = (tourLine, refreshParams, tour) => ({ type: Types.TOUR_LINE_DETAIL_UPDATE_ACTION, tourLine, refreshParams, tour });
export const createTourLine = (tourLine, refreshParams, tour) => ({ type: Types.TOUR_LINE_DETAIL_CREATE_ACTION, tourLine, refreshParams, tour });
export const deleteTourLine = (tourLine, refreshParams, tour) => ({ type: Types.TOUR_LINE_DETAIL_DELETE_ACTION, tourLine, refreshParams, tour });
export const deleteTourLineSucess = (id) => ({ type: Types.TOUR_LINE_DETAIL_DELETE_SUCCESS, id });
export const createTourLinesBulk = (tourLineBulk, refreshParams) => ({ type: Types.TOUR_LINE_BULK_CREATE_ACTION, tourLineBulk, refreshParams });
export const updateTourLinesBulk = (tourLineBulk, refreshParams) => ({ type: Types.TOUR_LINE_BULK_UPDATE_ACTION, tourLineBulk, refreshParams });
export const deleteTourLinesBulk = (tourLines, refreshParams) => ({ type: Types.TOUR_LINE_BULK_DELETE_ACTION, tourLines, refreshParams });

export const createTourTranslate = (tour) => ({ type: Types.TOUR_CREATE_TRANSLATE_ACTION, tour });
export const updateTourTranslate = (tour) => ({ type: Types.TOUR_UPDATE_TRANSLATE_ACTION, tour });
export const deleteTourTranslate = (tour, refreshParams) => ({ type: Types.TOUR_DELETE_TRANSLATE_ACTION, tour, refreshParams });


// Tourline ticket

export const getItemTicket = (tourlineId) => ({ type: Types.TOUR_ITEM_TICKET_GET_ACTION, tourlineId });
export const setItemTicket = (itemTickets, tourlineId) => ({ type: Types.TOUR_ITEM_TICKET_GET_SUCCESS, itemTickets, tourlineId });

export const getItemTicketDetail = (id) => ({ type: Types.TOUR_ITEM_TICKET_DETAIL_ACTION, id })
export const setItemTicketDetail = (itemTicket) => ({ type: Types.TOUR_ITEM_TICKET_DETAIL_SUCCESS, itemTicket });

export const updateItemTicketDetail = (itemTicket) => ({ type: Types.TOUR_ITEM_TICKET_DETAIL_UPDATE_ACTION, itemTicket });
export const createItemTicketDetail = (itemTicket) => ({ type: Types.TOUR_ITEM_TICKET_DETAIL_CREATE_ACTION, itemTicket });
export const deleteItemTicketDetail = (itemTicket) => ({ type: Types.TOUR_ITEM_TICKET_DETAIL_DELETE_ACTION, itemTicket });

export const openTourlineBulk = (isOpen) => ({ type: Types.TOUR_ITEM_MODAL_BULK_ACTION, isOpen });

export const dataAllTourAction = (filters) => ({ type: Types.TOUR_LIST_ALL_ACTION, filters });
export const dataAllTourSuccess = (allTours) => ({ type: Types.TOUR_LIST_ALL_SUCCESS, allTours });

export const getTourLineTickets = (params) => ({ type: Types.TOUR_LINE_TICKET_GET_ACTION, params });
export const getTourLineTicketsSuccess = (tourLineTickets) => ({ type: Types.TOUR_LINE_TICKET_GET_SUCCESS, tourLineTickets });


export const getDetailTourTicketAction = (params) => ({ type: Types.DETAIL_TOUR_TICKET_GET_ACTION, params });
export const setDetailTourTicketSuccess = (data) => ({ type: Types.DETAIL_TOUR_TICKET_GET_SUCCESS, data });

export const getDetailTourTicketDetailAction = (id) => ({ type: Types.DETAIL_TOUR_TICKET_DETAIL_ACTION, id });
export const setDetailTourTicketDetailSuccess = (tourTicket) => ({ type: Types.DETAIL_TOUR_TICKET_DETAIL_SUCCESS, tourTicket });

export const deleteDetailTourTicketAction = (tourTicket, filters) => ({ type: Types.DETAIL_TOUR_TICKET_DETAIL_DELETE_ACTION, tourTicket, filters });
export const updateDetailTourTicketAction = (tourTicket) => ({ type: Types.DETAIL_TOUR_TICKET_DETAIL_UPDATE_ACTION, tourTicket });
export const createDetailTourTicketAction = (tourTicket, copy) => ({ type: Types.DETAIL_TOUR_TICKET_DETAIL_CREATE_ACTION, tourTicket, copy });

export const createDetailTourTicketTranslate = (tourTicket) => ({ type: Types.DETAIL_TOUR_TICKET_CREATE_TRANSLATE_ACTION, tourTicket });
export const updateDetailTourTicketTranslate = (tourTicket) => ({ type: Types.DETAIL_TOUR_TICKET_UPDATE_TRANSLATE_ACTION, tourTicket });
export const deleteDetailTourTicketTranslate = (tourTicket, refreshParams) => ({ type: Types.DETAIL_TOUR_TICKET_DELETE_TRANSLATE_ACTION, tourTicket, refreshParams });

export const getAllTagSKUVW = () => ({ type: Types.TAGSKUVW_GET_ALL_ACTION });
export const setAllTagSKUVW = (tagSKUVW) => ({ type: Types.TAGSKUVW_GET_ALL_SUCCESS, tagSKUVW });
export const getTagSKUVWDetail = (id) => ({ type: Types.TAGSKUVW_DETAIL_ACTION, id });
export const setTagSKUVWDetail = (tagSKUVW) => ({ type: Types.TAGSKUVW_DETAIL_SUCCESS, tagSKUVW });
export const updateTagSKUVW = (tagSKUVW) => ({ type: Types.TAGSKUVW_DETAIL_UPDATE_ACTION, tagSKUVW });
export const createTagSKUVW = (tagSKUVW) => ({ type: Types.TAGSKUVW_DETAIL_CREATE_ACTION, tagSKUVW });
export const deleteTagSKUVW = (tagSKUVW, refreshParams) => ({ type: Types.TAGSKUVW_DETAIL_DELETE_ACTION, tagSKUVW, refreshParams });
